import { use } from 'react';

import { ClientConfigContext } from 'contexts/ClientConfigContext';

export default function useClientConfig() {
  return use(ClientConfigContext);
}
